module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "c-footer js-footer u-flex u-flex-jc--center u-fit-w u-pad-y-md@md",
    class: [_vm.footerIsFixedBottom ? 'is-fixed' : '']
  }, [_c('div', {
    staticClass: "c-footer__container u-flex u-flex-jc--space-between u-flex-jc--center@md u-flex-ai--center u-flex-ai--start@md u-flex-fd--column-reverse@md u-w8of10"
  }, [_c('div', {
    staticClass: "u-marg-t-md@md u-flex"
  }, [_c('p', {
    staticClass: "t-text--xxxs",
    domProps: {
      "innerHTML": _vm._s(_vm.content.label_copyright)
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "u-flex u-flex-fd--column@md"
  }, _vm._l((_vm.content.pages), function(page, index) {
    return _c('div', {
      staticClass: "c-footer__link u-marg-t-xxs@md u-marg-l-md u-marg-l-0@md",
      class: [index === 0 ? 'is-first' : '']
    }, [_c('router-link', {
      staticClass: "c-footer__link__element u-relative u-click-area-xxs t-link",
      attrs: {
        "to": _vm.$root.getPageURLFromName(page.page.post_name)
      }
    }, [_c('span', {
      staticClass: "t-text--xxxs",
      domProps: {
        "innerHTML": _vm._s(page.label)
      }
    })])], 1)
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "u-marg-l-md t-text--xxxs"
  }, [_c('span', {
    staticClass: "u-color--black-near u-opacity--40"
  }, [_vm._v("Site by ")]), _c('a', {
    staticClass: "c-footer__credit-link u-relative u-click-area-xxxs t-link",
    attrs: {
      "href": "https://immersive-g.com",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('span', [_vm._v("Immersive Garden")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b0e8579"}!./src/scripts/components/app-footer/template.html
// module id = 200
// module chunks = 0